import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type ContactId = string;

export interface ContactState extends BaseReducerState<ContactId> {
    unsaved: {},
    saved: {},
    new: '',
    
    createFlowId: string | null
}

export const initialContactState: ContactState = {
    ...baseReducerState,
    unsaved: {},
    saved: {},
    new: '',
    
    createFlowId: null
}